// {
//   "name": "iconic-letter-animation-second.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get("iconic-letter-animation-second")) {
    return;
  }

  class IconicLetterAnimationSecond extends HTMLElement {
    constructor() {
      super();

      this.initAnimationSecond = this.initAnimationSecond.bind(this);
    }

    connectedCallback() {
      this.initAnimationSecond();

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", this.initAnimationSecond);
        document.addEventListener("shopify:section:unload", this.initAnimationSecond);
        document.addEventListener("shopify:section:select", this.initAnimationSecond);
        document.addEventListener("shopify:section:deselect", this.initAnimationSecond);
        document.addEventListener("shopify:section:reorder", this.initAnimationSecond);
        document.addEventListener("shopify:block:select", this.initAnimationSecond);
        document.addEventListener("shopify:block:deselect", this.initAnimationSecond);
      }
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
      if (Shopify.designMode) {
        document.removeEventListener( "shopify:section:load",this.initAnimationSecond);
        document.removeEventListener("shopify:section:unload",this.initAnimationSecond);
        document.removeEventListener("shopify:section:select",this.initAnimationSecond);
        document.removeEventListener("shopify:section:deselect",this.initAnimationSecond);
        document.removeEventListener("shopify:section:reorder",this.initAnimationSecond);
        document.removeEventListener("shopify:block:select",this.initAnimationSecond);
        document.removeEventListener("shopify:block:deselect",this.initAnimationSecond);
      }
    }
    initAnimationSecond() {
      const sections = document.querySelectorAll(
        "[data-iconic-letter-animation]"
      );

      sections.forEach((section) => {
        const ANIMATION_SPEED =
          section.getAttribute("data-iconic-animation-speed") || 0.6;
        const paragraphs = section.querySelectorAll(
          ".iconic-animation-2 .iconic-letter-item p"
        );

        const handleScroll = () => {
          const currentScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

          paragraphs.forEach((p) => {
            const rect = p.getBoundingClientRect();
            const isVisible =
              rect.top >= 0 && rect.bottom <= window.innerHeight;

            if (isVisible) {
              p.style.transition = `opacity ${ANIMATION_SPEED}s ease-in-out, transform ${ANIMATION_SPEED}s ease-in-out`;
              p.style.opacity = 1;
              p.style.transform = "translateY(0) scale(1)";
            } else {
              p.style.transition = `opacity ${ANIMATION_SPEED}s ease-in-out, transform ${ANIMATION_SPEED}s ease-in-out`;
              p.style.opacity = 0;
              p.style.transform = "translateY(20px) scale(0.95)";
            }
          });
        };

        // Attach the scroll event
        window.addEventListener("scroll", handleScroll);
        handleScroll();
      });
    }
  }
  customElements.define("iconic-letter-animation-second", IconicLetterAnimationSecond);
})();
